import * as React from 'react';
import { FontIcon, IFontIconProps } from 'office-ui-fabric-react';

import styles from './NewIndicator.module.scss';

export const NewIndicator: React.FunctionComponent<IFontIconProps> = () => {
    return <FontIcon iconName="Glimmer" className={styles.newIndicator} />;
};
